<template>
    <div class="container-page py-10 md:py-14">
        <SectionHeading title="My Experience" />

        <ol class="relative space-y-5">
            <li v-for="job in jobs" :key="job.company + job.period" class="card p-6 sm:p-9">
                <div class="grid gap-5 md:grid-cols-[220px_1fr] md:gap-12">
                    <div>
                        <span class="chip">{{ job.period }}</span>
                        <p class="mt-4 font-display text-[18px] font-semibold text-ink">{{ job.company }}</p>
                    </div>

                    <div>
                        <h3 class="font-display text-[22px] font-semibold leading-snug tracking-[-0.01em] text-ink">{{ job.role }}</h3>
                        <ul class="mt-4 space-y-2.5">
                            <li v-for="(point, i) in job.points" :key="i"
                                class="relative pl-5 text-[15.5px] leading-[1.7] text-ink-2 before:absolute before:left-0 before:top-[0.7em] before:h-1.5 before:w-1.5 before:rounded-full before:bg-accent/60">
                                {{ point }}
                            </li>
                        </ul>
                    </div>
                </div>
            </li>
        </ol>
    </div>
</template>

<script>
import SectionHeading from '@/components/ui/SectionHeading.vue'

export default {
    components: { SectionHeading },
    data() {
        return {
            jobs: [
                {
                    period: 'Nov 2025 — May 2026',
                    company: 'elerra motiv GmbH',
                    role: 'Backend Software Engineer',
                    points: [
                        'Built and operated CloudDiagnostix, a production-ready cloud-native vehicle diagnostics and fleet monitoring platform used across more than 10 electric vehicles.',
                        'Designed FastAPI microservices for ingesting, decoding, storing, and streaming GPS, IO, and CAN/J1939 telemetry with PostgreSQL, Redis, NATS JetStream, and WebSockets.',
                        'Load-tested the telemetry pipeline with Prometheus and Grafana, sustaining approximately 2,200 telemetry records per second with 45 ms P95 batch-processing latency and no processing failures across 10 concurrent vehicle streams.',
                        'Deployed containerized backend services on AWS EKS using Docker, Helm, and Terraform.',
                        'Integrated an AI-powered diagnostic assistant with LangChain and OpenAI tool-calling.',
                        'Wrote unit and integration tests with pytest to validate APIs, telemetry processing, and business workflows.'
                    ]
                },
                {
                    period: 'Mar 2025 — Feb 2026',
                    company: 'aucobo GmbH',
                    role: 'Freelance Backend Engineer (Part-time)',
                    points: [
                        'Developed backend integrations, REST APIs, and JWT-based authentication using Firebase Authentication, alongside push notification services and production backend features.',
                        'Built and maintained GitHub Actions CI/CD pipelines, automating Docker builds and deployments to AWS EKS through release workflows.',
                        'Managed client communication, technical scoping, implementation, testing, and production delivery independently throughout the project lifecycle.'
                    ]
                },
                {
                    period: 'Jul 2024 — Jan 2025',
                    company: 'HAVELSAN',
                    role: 'Software Developer Intern',
                    points: [
                        'Developed LOADMAN, a performance testing web application that allows users to execute stress tests on their websites using JMeter and K6.',
                        'Designed and implemented the frontend using Vue.js, creating an intuitive interface for users to upload API files and manage tests.',
                        'Built a scalable backend system with TypeScript and Express, enabling efficient test execution and API management.',
                        'Deployed distributed performance tests on Kubernetes, automating pod creation for executing JMeter and K6 tests in isolated environments.',
                        'Integrated MongoDB for reliable data storage and management, ensuring seamless retrieval and analysis of test results.',
                        'Focused on delivering a robust, scalable, and user-friendly solution, enabling clients to analyze and improve their web application performance effectively.'
                    ]
                },
                {
                    period: 'Aug 2023 — Sep 2023',
                    company: 'Karel Electronic',
                    role: 'Software Developer Intern',
                    points: [
                        'Designed and developed a mobile application at Karel Electronic to track staff working hours. The app records entry and exit times for efficient time management.',
                        'Created a robust backend system using FastAPI, ensuring seamless operation and integration with the mobile application.',
                        'Utilized MongoDB for storing and managing data effectively, enabling reliable data retrieval and storage.'
                    ]
                }
            ]
        };
    }
};
</script>
